// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xHj6","label":"styles_label__3GTyq"};